"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const getPreviewCookie = require("./getPreviewCookie.cjs");
const isReleasePreview = () => {
  return /\/previews\/.*~.*\?websitePreviewId/.test(getPreviewCookie.getPreviewCookie() || "");
};
exports.isReleasePreview = isReleasePreview;
//# sourceMappingURL=isReleasePreview.cjs.map
